import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { setcategory } from "../../actions/setcategoryaction";
import AlertDialogBox from "../DailogBoxes/alertdailogbox";
import Service from "../../Service/firebase";
import ErorrDialogBox from "../DailogBoxes/errordaologbox";
import EditCategoryForm from "../Category/editcategoryform";

import "react-datepicker/dist/react-datepicker.css";

const EditCategory = (props) => {
  const [image, setImage] = useState("");
  const [profileHtmlElement, setProfileHtmlElement] = useState(
    <i className="fa fa-user fa-8x" aria-hidden="true"></i>
  );
  const [isLoading, setIsLoading] = useState(false);
  const [openAlertDailog, setOpenAlertDailog] = useState(false);
  const [openErrorDailog, setOpenErrorDailog] = useState(false);
  const [category, setCategory] = useState({
    name: props.category.name,
    imageurl: props.category.imageurl,
    categoryId: props.category.categoryId,
    isActive: props.category.isActive !== undefined ? props.category.isActive : true,
    collectionName: props.category.collectionName,
  });

  const handleSubmit = () => {
    setIsLoading(true);

    handleImageForUpload();
  };
  const handleImageForUpload = () => {
    if (image !== "") {
      onUploadImage(image);
    } else {
      onUpdate();
    }
  };
  const onUploadImage = async (image) => {
    const url = await Service.uploadImage(image, "categoryIcons");
    if (url !== "") {
      onUpdate(url);
    }
  };
  const onUpdate = async (imageUrl) => {
    const sendData = {
      ...category,
      ...(imageUrl && { imageurl: imageUrl }), // Include new imageUrl if provided
    };
    const res = await Service.updateData(
      sendData,
      props.category.collectionName,
      props.category.category_uid
    );
    if (res === "success") {
      setIsLoading(false);
      setOpenAlertDailog(true);

      const updatedCategory = {
        ...sendData,
        collectionName: props.category.collectionName,
        category_uid: props.category.category_uid,
      };

      props.setOncategory(updatedCategory);
    } else {
      setIsLoading(false);
      handleErrorDailog();
    }
  };
  const handleErrorDailog = () => {
    setOpenErrorDailog(true);
  };
  const closeErrorDailog = () => {
    setOpenAlertDailog(false);
  };
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImage(event.target.files[0]);
      let reader = new FileReader();
      reader.onload = (e) => {
        setCategory({
          ...category,
          imageurl: e.target.result,
        });
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };
  const onImageRemove = () => {
    setCategory({
      ...category,
      imageurl: "",
    });
    setImage("");
  };

  const onEdit = (e) => {
    const { name, value, type, checked } = e.target;
    setCategory({
      ...category,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  const handleSetOpenDailog = () => {
    setOpenAlertDailog(false);
  };

  useEffect(() => {
    if (category.imageurl === "") {
      setProfileHtmlElement(
        <div className="editcategorypage">
          <i className="fa fa-user fa-8x" aria-hidden="true"></i>
        </div>
      );
    } else {
      setProfileHtmlElement(
        <div className="editcategorypage">
          <img className="netimage" srcSet={category.imageurl} alt="" />
        </div>
      );
    }
  }, [category.imageurl]);

  return isLoading ? (
    <div className="editcategorypage">
      <i
        className="fas fa-spinner fa-pulse fa-4x"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      ></i>
    </div>
  ) : (
    <div className="editcategorypage">
      <AlertDialogBox
        openDailog={openAlertDailog}
        setOpenDailog={setOpenAlertDailog}
        onSetOpenDailog={handleSetOpenDailog}
        title="Update"
        des="successfully updated"
      ></AlertDialogBox>
      <ErorrDialogBox
        openDailog={openErrorDailog}
        onSetOpenDailog={closeErrorDailog}
        title="Error"
        des="Someting went wrong. Try again"
      ></ErorrDialogBox>
      <EditCategoryForm
        handleSubmit={handleSubmit}
        onEdit={onEdit}
        category={category}
        profileHtmlelEment={profileHtmlElement}
        onImageRemove={onImageRemove}
        onImageChange={onImageChange}
        handleImageForUpload={handleImageForUpload}
      ></EditCategoryForm>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    category: state.category,
  };
};
const mapDisptachToProps = (dispatch) => {
  return {
    setOncategory: (p) => {
      dispatch(setcategory(p));
    },
  };
};
export default connect(mapStateToProps, mapDisptachToProps)(EditCategory);
